import ValidatedMutation from '@/api/validated-mutation';

export default {
  data() {
    return {
      errors: {},
      isSubmitting: false,
    };
  },
  methods: {
    async submit(callback) {
      this.isSubmitting = true;
      try {
        const result = await callback();
        if (result.isValid) {
          this.errors = {};
        } else {
          this.errors = result.errors;
        }
        this.isSubmitting = false;
        return result;
      } catch (error) {
        this.isSubmitting = false;
        throw error;
      }
    },
    submitWithAction(...rest) {
      return this.submit(() => this.$store.dispatch(...rest));
    },
    submitWithMutation(options = {}) {
      return this.submit(() => ValidatedMutation.mutate(options));
    },
  },
};



// WEBPACK FOOTER //
// ./mixins/Submittable.js